import { render, staticRenderFns } from "./photo-slider.vue?vue&type=template&id=3d9d54ea&scoped=true&"
import script from "./photo-slider.vue?vue&type=script&lang=js&"
export * from "./photo-slider.vue?vue&type=script&lang=js&"
import style0 from "./photo-slider.vue?vue&type=style&index=0&id=3d9d54ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9d54ea",
  null
  
)

export default component.exports